import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import AgencyFeeFactory from "../../Entity/Factories/AgencyFeeFactory";
import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import Translator from "../../Translation/Translator";

export default function* agencyFeeCreateDefault(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_REQUEST
    });

    const res = yield call(Http.post, `agency-fees-default`, action.payload);

    const agencyFee: AgencyFeeInterface = AgencyFeeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_SUCCESS,
      payload: {
        agencyFee: agencyFee
      }
    });

    if (!action.payload?.hideSnackbar) { 
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-default-agency-fee-created-successfully"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, agencyFee);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAgencyFeeCreateDefault() {
  yield takeEvery(Constants.GLOBAL_AGENCY_FEE_CREATE_DEFAULT_START, agencyFeeCreateDefault);
}
